import React from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import { cn } from 'lib/utils';

export default function FAQAccordion({
  title,
  questions,
  onClick,
  selectedQuestion,
  isOpen = false,
  onToggle = () => {}
}) {
  const hasSelectedQuestion = selectedQuestion
    ? questions.includes(selectedQuestion)
    : false;

  return (
    <div className='min-w-[280px] mb-2'>
      <button
        type='button'
        onClick={onToggle}
        className={cn(
          'text-xl w-full flex items-center justify-between gap-2 px-4 py-3.5 text-left font-semibold',
          'transition-colors outline-none focus:outline-none focus-visible:outline-none appearance-none border-0 cursor-pointer',
          isOpen ? 'rounded-t-xl' : 'rounded-xl',
          hasSelectedQuestion
            ? 'bg-lime-200 text-gray-900 hover:bg-lime-300'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        )}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <ChevronDown
          className={cn(
            'w-5 h-5 text-gray-500 shrink-0 transition-transform duration-200',
            isOpen && 'rotate-180'
          )}
          aria-hidden
        />
      </button>

      <div
        className={cn(
          'overflow-hidden transition-[max-height] duration-200 ease-out',
          isOpen ? 'max-h-[2000px]' : 'max-h-0'
        )}
      >
        {isOpen && (
          <ul
            className={cn(
              'list-none p-0 m-0 rounded-b-xl',
              hasSelectedQuestion ? 'bg-lime-50' : 'bg-gray-50'
            )}
          >
            {questions.map((question, index) => (
              <li key={question.id ?? index} className='list-none'>
                <button
                  type='button'
                  onClick={() => onClick(question)}
                  className={cn(
                    'w-full text-left cursor-pointer px-4 py-2.5 text-sm transition-colors border-0 bg-transparent',
                    selectedQuestion === question
                      ? hasSelectedQuestion
                        ? 'bg-lime-200 font-semibold text-gray-900 hover:bg-lime-300'
                        : 'bg-gray-200 font-semibold text-gray-900 hover:bg-gray-300'
                      : 'text-gray-700 hover:bg-black/5'
                  )}
                >
                  {question.question}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

FAQAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  questions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClick: PropTypes.func.isRequired,
  selectedQuestion: PropTypes.object,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func
};
